import {environment} from "@app/common/components/viewers/configurator/extensions/bd-cloud/environment/environment"
import {TraversalAction} from "@cm/graph-v3"
import {getOwnedNodes, OutputNode, TemplateGraph, TemplateInstance, TemplateReference} from "@cm/template-nodes"

/* There is a single quilt setup template, everything that deals with quilts recognizes them by an instance of it. */
export function isQuiltSetupInstance(node: unknown): node is TemplateInstance {
    if (!(node instanceof TemplateInstance)) return false
    const template = node.parameters.template
    return template instanceof TemplateReference && template.parameters.templateId === environment.quiltSetupTemplateId
}

/**
 * Removes quilt setup template instances from the root of the template graph that no output refers to anymore.
 * Those are left behind whenever the material slot holding the quilt is overwritten or dropped (e.g. when removing a layer).
 * Handles, accessories and pullers cannot carry quilts, removing those does not require this cleanup.
 */
export function removeUnreferencedQuiltSetups(templateGraph: TemplateGraph): void {
    const referenced = new Set<TemplateInstance>()
    templateGraph.depthFirstTraversalPreorder((node) => {
        if (node instanceof OutputNode) referenced.add(node.parameters.template)
        return TraversalAction.Continue
    })

    const unreferenced = getOwnedNodes(templateGraph).filter((node) => isQuiltSetupInstance(node) && !referenced.has(node))
    for (const node of unreferenced) templateGraph.parameters.nodes.removeEntry(node)
}
